var map = {
	"./academicachiever.png": [
		25074,
		5074
	],
	"./alien.png": [
		38587,
		8587
	],
	"./apple.png": [
		99353,
		9353
	],
	"./aroundtheworld.png": [
		73082,
		3082
	],
	"./avocado2022.png": [
		50736,
		736
	],
	"./avocado2023.png": [
		17015,
		7015
	],
	"./banana.png": [
		57956,
		7956
	],
	"./baseball.png": [
		18899,
		8899
	],
	"./basketball.png": [
		85658,
		5658
	],
	"./beaker.png": [
		54813,
		4813
	],
	"./boat.png": [
		64315,
		4315
	],
	"./book.png": [
		10082,
		2158
	],
	"./camera.png": [
		39545,
		9545
	],
	"./campfirering2023.png": [
		99368,
		9741
	],
	"./cat.png": [
		46461,
		6461
	],
	"./chavocado2023.png": [
		68414,
		8414
	],
	"./cheese2022.png": [
		38559,
		8559
	],
	"./cheese2023.png": [
		91272,
		1272
	],
	"./cloud.png": [
		70403,
		403
	],
	"./colorfulcreative.png": [
		29000,
		9000
	],
	"./communitychampion.png": [
		11696,
		1696
	],
	"./confidencebuilder.png": [
		61555,
		1555
	],
	"./coolcamper.png": [
		89579,
		9579
	],
	"./dino.png": [
		53564,
		3564
	],
	"./dog.png": [
		10186,
		186
	],
	"./donut.png": [
		54918,
		4918
	],
	"./face1.png": [
		80991,
		1052
	],
	"./face10.png": [
		61699,
		1699
	],
	"./face12.png": [
		5272,
		5272
	],
	"./face13.png": [
		63550,
		3550
	],
	"./face14.png": [
		40427,
		427
	],
	"./face15.png": [
		32547,
		2547
	],
	"./face2.png": [
		67831,
		7831
	],
	"./face3.png": [
		57738,
		7738
	],
	"./face4.png": [
		64609,
		4609
	],
	"./face5.png": [
		15517,
		5517
	],
	"./face6.png": [
		38499,
		8499
	],
	"./face7.png": [
		67124,
		7124
	],
	"./face8.png": [
		43548,
		3548
	],
	"./face9.png": [
		92043,
		2043
	],
	"./fish.png": [
		88701,
		8701
	],
	"./flower.png": [
		17198,
		7198
	],
	"./gameconcontroller.png": [
		18757,
		8757
	],
	"./gameconshield.png": [
		24313,
		4313
	],
	"./goco2022.png": [
		10502,
		502
	],
	"./goco24avo.png": [
		976,
		976
	],
	"./goco24chavo.png": [
		48273,
		8273
	],
	"./goco24cheese.png": [
		23611,
		3611
	],
	"./goco24tent.png": [
		96916,
		6916
	],
	"./gocowelcome2023.png": [
		78390,
		8390
	],
	"./hat.png": [
		89043,
		9043
	],
	"./hummingbird.png": [
		15391,
		5391
	],
	"./koala.png": [
		22126,
		2126
	],
	"./makers.png": [
		36248,
		6248
	],
	"./moneymakersmonth.png": [
		3908,
		3908
	],
	"./mug.png": [
		93545,
		3545
	],
	"./outschooltalentmonth.png": [
		86479,
		6479
	],
	"./outvillecider2023.png": [
		76378,
		6378
	],
	"./outvillekey2023.png": [
		18633,
		8633
	],
	"./outvilleleaf2023.png": [
		61715,
		1715
	],
	"./outvillewelcome2023.png": [
		51587,
		1587
	],
	"./owl.png": [
		12789,
		2789
	],
	"./planet.png": [
		68843,
		8843
	],
	"./rubix.png": [
		96583,
		6583
	],
	"./star.png": [
		44342,
		4342
	],
	"./steammonth2023.png": [
		87170,
		7170
	],
	"./studyninja.png": [
		64006,
		4006
	],
	"./sun.png": [
		82671,
		2671
	],
	"./superstar.png": [
		69685,
		9685
	],
	"./unicorn.png": [
		23334,
		3334
	],
	"./worldartandliteraturemonth.png": [
		58785,
		8785
	],
	"./worldbuilder.png": [
		31947,
		1947
	],
	"./writersmonth.png": [
		92994,
		2994
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 46951;
module.exports = webpackAsyncContext;